import React from 'react';
import ReactModal from 'react-modal';
import { MdClose } from "react-icons/md";

import {
  ModalHeader,
  ModalTitle,
  ModalBody,
  CloseButton,
  ButtonContainer,
} from './styledComponents';

import './UllrModal.css';

export const UllrModal = (props) => {

  return (
    <ReactModal
      isOpen={props.isOpen}

      onAfterOpen={props.onAfterOpen} /* Function that will be run after the modal has opened. */
      onAfterClose={props.onAfterClose}/* Function that will be run after the modal has closed. */
      onRequestClose={props.onRequestClose} /* Function that will be run when the modal is requested to be closed (either by clicking on overlay or pressing ESC). Note: It is not called if isOpen is changed by other means. */

      closeTimeoutMS={props.closeTimeoutMS} /* Number indicating the milliseconds to wait before closing the modal. */

      style={
        {
          overlay: { zIndex: 1000 },
          content: {
            maxHeight: '95vh',
            display: 'flex',
            flexDirection: 'column',
            ...props.style
          },
        }
      /* Obor more detaiject indicating styles to be used for the modal.
        It has two keys, `overlay` and `content`.
        See the `Styles` section fls. */}

      contentLabel={
        "Modal"
      /* String indicating how the content container should be announced
        to screenreaders */}

      // portalClassName={
      //   "ReactModalPortal"
      // /* String className to be applied to the portal.
      //   See the `Styles` section for more details. */}

      // overlayClassName={
      //   "ReactModal__Overlay"
      // /* String className to be applied to the overlay.
      //   See the `Styles` section for more details. */}

      // id={
      //   "some-id"
      // /* String id to be applied to the content div. */}

      // className={
      //   "ReactModal__Content"
      // /* String className to be applied to the modal content.
      //   See the `Styles` section for more details. */}

      // bodyOpenClassName={
      //   "ReactModal__Body--open"
      // /* String className to be applied to the document.body 
      //   (must be a constant string).
      //   This attribute when set as `null` doesn't add any class 
      //   to document.body.
      //   See the `Styles` section for more details. */}

      // htmlOpenClassName={
      //   "ReactModal__Html--open"
      // /* String className to be applied to the document.html
      //   (must be a constant string).
      //   This attribute is `null` by default.
      //   See the `Styles` section for more details. */}

      ariaHideApp={
        true
      /* Boolean indicating if the appElement should be hidden */}

      shouldFocusAfterRender={true}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={false}
      shouldReturnFocusAfterClose={true}

      role={
        "dialog"
      /* String indicating the role of the modal, allowing the 'dialog' role
        to be applied if desired.
        This attribute is `dialog` by default. */}

      parentSelector={
        () => document.body
      /* Function that will be called to get the parent element
        that the modal will be attached to. */}

      data={
        { background: "green" }
      /* Additional data attributes (optional). */}

      // overlayRef={
      //   setOverlayRef
      // /* Overlay ref callback. */}

      // contentRef={
      //   setContentRef
      // /* Content ref callback. */}
    >
      <ModalHeader>
        {
          /* `headerContent` lets callers render a custom header (e.g. an icon +
             title + subtitle block) inline with the close button, instead of
             the centered `headerTitle` text. */
          props.headerContent
            ? (
              <div style={{ flex: 1, minWidth: 0, marginRight: 16 }}>
                {props.headerContent}
              </div>
            )
            : (
              <>
                <span></span>
                <ModalTitle>{props.headerTitle}</ModalTitle>
              </>
            )
        }
        <CloseButton
          onClick={() => props.close()}
        >
          <MdClose />
        </CloseButton>
      </ModalHeader>
      <ModalBody style={{
        ...props.bodyStyle,
      }}>
        {props.children}
      </ModalBody>
    </ReactModal>
  );
}

export const UllrModalButtonContainer = ButtonContainer;